module.exports = __webpack_public_path__ + "img/logo_efishery.b0f21679.png";